import { getPrefix, getSessionToken } from "../bandung";
import { objectToFormData } from "./helpers";
import Axios from "axios";

const getImagePrefix = () => `${getPrefix()}/app/image`;

const getImageCreateEndPoint = () => `${getImagePrefix()}/create`;
const getImageDeleteEndPoint = () => `${getImagePrefix()}/delete`;
const getImageImageEndPoint = (
  imageEntityId,
  imageVersion) => `${getImagePrefix()}/imageimage?imageEntityId=${imageEntityId}&t=${imageVersion}`;
const getImageListEndPoint = () => `${getImagePrefix()}/list`;
const getImageUpdateImageEndPoint = () => `${getImagePrefix()}/updateimage`;
const getImageUploadImageEndPoint = () => `${getImagePrefix()}/uploadimage`;
const getImageViewEndPoint = () => `${getImagePrefix()}/view`;

const imageCreate = async ({
  imageName,
  imageCredit,
  imageLabel,
  imageType,
  imageUrl,
}) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    imageName: imageName,
    imageCredit: imageCredit,
    imageLabel: imageLabel,
    imageType: imageType,
    imageUrl: imageUrl,
  });
  try {
    const response = await Axios.post(getImageCreateEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Image created successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const imageDelete = async (imageEntityId) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    imageEntityId: imageEntityId,
  });
  try {
    const response = await Axios.post(getImageDeleteEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Image deleted successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const imageList = async (page) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    page: page,
  });
  try {
    const response = await Axios.post(getImageListEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "images loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const imageUpdateImage = async ({
  imageEntityId,
  imageName,
  imageCredit,
  imageLabel,
  imageType,
  imageUrl,
}) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    imageEntityId: imageEntityId,
    imageName: imageName,
    imageCredit: imageCredit,
    imageLabel: imageLabel,
    imageType: imageType,
    imageUrl: imageUrl,
  });
  try {
    const response = await Axios.post(getImageUpdateImageEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Image updated successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const imageUploadImage = async (image, imageEntityId, onUpload) => {
  const form = objectToFormData({
    "sessionToken": getSessionToken(),
    "imageEntityId": imageEntityId,
    "image": image,
  });

  try {
    const response = await Axios.post(
      getImageUploadImageEndPoint(),
      form, {
        onUploadProgress: (progressEvent) => onUpload(progressEvent),
      });
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "New image saved.",
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const imageView = async (imageEntityId) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    imageEntityId: imageEntityId,
  });
  try {
    const response = await Axios.post(getImageViewEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Image loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

export {
  getImageImageEndPoint,
  imageCreate,
  imageDelete,
  imageList,
  imageUpdateImage,
  imageUploadImage,
  imageView,
};